import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IPackageCard } from "../../../Pages/PackageManagement/IPacakageManagement";

export const PackagemanagementCardSlicer = createSlice({
  name: "PackageManagementCard",
  initialState: { isLoading: false, data: {} } as IReduxState<IPackageCard[]>,
  reducers: {
    packageManagementCard: (state,_) => {
      state.isLoading = true;
    },
    successPackageManagementCard: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failurePackageManagementCard: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { packageManagementCard, successPackageManagementCard, failurePackageManagementCard } =
  PackagemanagementCardSlicer.actions;

export default PackagemanagementCardSlicer.reducer;
